import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CompetitorAnalysis, CreateCompetitorAnalysisRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateCompetitorAnalysis() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCompetitorAnalysisRequest) =>
      apiPost<CompetitorAnalysis>('/v1/competitor-analyses', input, {
        headers: { 'idempotency-key': crypto.randomUUID() },
      }),
    onSuccess: (analysis) => {
      void qc.invalidateQueries({ queryKey: ['competitor-analyses'] });
      qc.setQueryData(['competitor-analysis', analysis.id], analysis);
    },
  });
}
